import type { WorkSession } from "@/types/workSession.type";

export function isOvernightSession(session: WorkSession): boolean {
    if (!session.endTime) return false;
    const startDate = new Date(session.startTime);
    const endDate = new Date(session.endTime);
    return endDate.toDateString() !== startDate.toDateString();
}